// Auto-generated from translation.csv; do not edit manually
export const ptPT = {
  "accountGuide": {
    "content": "Abra qualquer jogo da Touka, acesse a tela de configurações do jogo, vincule seu e-mail para aproveitar descontos em produtos especiais!",
    "title": "Como criar uma conta?"
  },
  "bottomNav": {
    "home": "Página inicial",
    "myOrders": "Meus pedidos"
  },
  "common": {
    "loading": "Carregando...",
    "noData": "Sem dados",
    "server": "Servidor"
  },
  "footer": {
    "language": "Chinês (Simplificado)",
    "privacyPolicy": "Política de privacidade",
    "refundPolicy": "Política de reembolso",
    "termsOfService": "Termos de serviço",
    "userSupport": "Suporte ao usuário",
    "downloadNow": "Baixar agora!"
  },
  "header": {
    "characterName": "Nome do personagem",
    "gameServer": "Servidor do jogo",
    "selectGameServer": "Selecionar região do jogo",
    "greeting": "Olá",
    "loginPrompt": "Por favor, clique para entrar",
    "switchServer": "Alternar",
    "title": "Plataforma de recarga do jogo",
    "logout": "Sair"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Oopsie Croco"
  },
  "history": {
    "backToGameZone": "Voltar à loja do jogo",
    "allGames": "Todos os jogos",
    "empty": "Ainda não há pedidos aqui～",
    "filter": {
      "all": "Tudo",
      "closed": "Fechado",
      "completed": "Concluído",
      "inProgress": "Em andamento",
      "pendingDelivery": "Aguardando envio"
    },
    "orderTime": "Hora do pedido:",
    "pendingAutoCancelPrefix": "O pedido será cancelado em",
    "pendingAutoCancelSuffix": "automaticamente",
    "cancelOrder": "Cancelar pedido",
    "payOrder": "Pagar",
    "cancelOrderConfirmTitle": "Confirmar cancelamento do pedido?",
    "cancelOrderConfirmPrimary": "Confirmar",
    "cancelOrderDismiss": "Agora não",
    "status": {
      "cancelled": "Cancelado",
      "completed": "Transação concluída",
      "paid": "Pago",
      "pending": "Aguardando pagamento",
      "shipped": "Enviado"
    }
  },
  "home": {
    "selectGame": "Selecione o jogo que deseja recarregar",
    "selectGameParts": {
      "prefix": "Selecione o jogo que deseja ",
      "keyword": "recarregar",
      "suffix": ""
    },
    "noRoleAccount": "Ainda não tem personagem neste jogo. Crie um no jogo antes de comprar.",
    "noRoleRefreshPrefix": "Já criou uma conta? Toque em ",
    "noRoleRefreshAction": "Atualizar",
    "noRoleRefreshing": "A atualizar…",
    "noRoleRefreshNotFound": "Não foram encontradas informações do personagem",
    "noRoleRefreshFailed": "Falha ao atualizar. Tente novamente mais tarde."
  },
  "login": {
    "agreeTerms": {
      "and": "e",
      "prefix": "Eu li e concordo com",
      "privacy": "Política de Privacidade",
      "terms": "Termos de Serviço"
    },
    "cancel": "Cancelar",
    "bindGameGuide": "Aviso de vinculação ao jogo",
    "bindGameGuideContent": "Abra qualquer jogo Touka,\nvá às definições no jogo,\nvincule o seu e-mail\ne aproveite descontos especiais na loja!",
    "captchaPlaceholder": "Código de verificação",
    "invalidCaptcha": "Por favor, insira um código de verificação de 4 dígitos",
    "email": "E-mail",
    "emailNotBound": "Falha na recuperação, por favor insira o e-mail vinculado dentro do jogo~",
    "emailPlaceholder": "Por favor, insira seu e-mail eletrônico",
    "keepLogin": "Manter login por 15 dias",
    "loading": "Entrando...",
    "loginToStore": "Entrar na Touka Store",
    "noAccount": "Ainda não tem uma conta?",
    "password": "Senha",
    "passwordPlaceholder": "Por favor, insira a senha",
    "submit": "Entrar",
    "title": "Entrar",
    "invalidEmail": "Introduza um endereço de e-mail válido"
  },
  "logout": {
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "dontRemind": "Não lembrar da próxima vez",
    "messageLine1": "Após sair da conta, em todos os dispositivos nos últimos 30 dias",
    "messageLine2": "O estado de login será inválido.",
    "title": "Dica amigável"
  },
  "menu": {
    "contactSupport": "Contato com o atendimento ao cliente ",
    "gameList": "Lista de jogos ",
    "myOrders": "Meus pedidos "
  },
  "paymentSuccess": {
    "account": "Conta: ",
    "celebrationTitle": "Compra bem-sucedida",
    "confirm": "Confirmar ",
    "getPaymentInfoFailed": "Falha ao obter informações de pagamento ",
    "loading": "Carregando... ",
    "orderDate": "Data do pedido: ",
    "orderId": "Número do pedido: ",
    "paymentMethod": "Método de pagamento: ",
    "paypal": "PayPal ",
    "price": "Preço: ",
    "purchaseContent": "Conteúdo da compra: ",
    "quantity": "Quantidade comprada: ",
    "serverAndCharacter": "Servidor/Personagem: ",
    "title": "Obrigado pela compra",
    "total": "Todos: ",
    "unionPay": "UnionPay ",
    "amountPaid": "Valor pago:",
    "closeModal": "Fechar"
  },
  "productModal": {
    "confirm": "Confirmar ",
    "purchaseDetails": "Detalhes da compra ",
    "quantity": "Quantidade: ",
    "total": "Todos: ",
    "unitPrice": "Preço unitário: "
  },
  "products": {
    "giftPacks": "Pacote de brindes ",
    "diamond": "Diamante ",
    "products": "Produto ",
    "vouchers": "Voucher ",
    "toukaCoin": "Touka Coin",
    "toukaCoinBonusTip": "Compre na TOUKA Store e ganhe 10% extra de recompensa!",
    "superValue": "Super valor",
    "limitShort": "Limite",
    "remainingShort": "Tempo rest.",
    "giftPackLimitType": {
      "lifetime": "Oferta vitalícia",
      "weekly": "Oferta semanal",
      "monthly": "Oferta mensal"
    },
    "howToUseVouchers": "Como usar Touka Coin?",
    "voucherGuide": {
      "title": "Como usar Touka Coin?",
      "step1": "1.Por favor, verifique o Touka Coin comprado na caixa de correio dentro do jogo.",
      "step2": "2.Você pode visualizar a quantidade de Touka Coins na parte superior da aba da loja do jogo. Quando a quantidade de Touka Coins atingir o necessário para comprar o pacote, os Touka Coins serão usados prioritariamente para a compra.",
      "backToProducts": "Voltar à lista de produtos"
    }
  },
  "purchaseConfirm": {
    "card": "Cartão de crédito/débito ",
    "confirm": "Confirmar ",
    "dontAskAgain": "Não perguntar novamente nos próximos 30 dias",
    "gameServer": "Grupo de jogo ",
    "paymentMethods": "Formas de pagamento suportadas ",
    "paypal": "PayPal ",
    "title": "Você tem certeza de que deseja comprar com esta conta? ",
    "unionPay": "Cartão UnionPay "
  },
  "serverSelect": {
    "characterLabel": "Nome do personagem ",
    "characterPlaceholder": "Por favor, selecione um personagem ",
    "confirm": "Confirmar ",
    "noResults": "Sem resultados ",
    "serverPlaceholder": "Nome do servidor",
    "title": "Selecionar região do jogo ",
    "title": "Selecionar grupo de jogo "
  },
  "support": {
    "cancel": "Cancelar ",
    "copied": "Copiado ",
    "copy": "Copiar com um clique ",
    "description": "Por favor, envie suas informações detalhadas pelo e-mail oficial ",
    "title": "Suporte ao cliente "
  },
  "verification": {
    "back": "Voltar ",
    "enterCode": "Por favor, insira o código de verificação para continuar ",
    "incorrectCode": "Código de verificação incorreto ",
    "invalidCode": "Por favor, insira o código de verificação de 6 dígitos ",
    "noCode": "Não recebeu o código? ",
    "sentTo": "O código de verificação foi enviado para ",
    "submit": "Enviar ",
    "submitting": "Enviando..."
  }
} as const;
